import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_MigrantInformationForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_MigrantInformationForm' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <center> <h4> <b> MIGRANT INFORMATION FORM </b> </h4> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> CLIENT NAME: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> MEDICAID NUMBER: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtClient_1' name='txtClient_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMedicaidNumber_1' name='txtMedicaidNumber_1' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <center> <h5> <b> FAMILY MEMBERS THAT MIGRATE </b> </h5> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> CLIENT NAME: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> CLIENT NAME: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtClientName_1' name='txtClientName_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtNameClient_1' name='txtNameClient_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtClientName_2' name='txtClientName_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtNameClient_2' name='txtNameClient_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtClientName_3' name='txtClientName_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtNameClient_3' name='txtNameClient_3' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> SOURCE(S) OF PAYMENT FOR MEDICAL CARE IF FAMILY MIGRATES OUTSIDE OF TEXAS: </span>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbMigrates_1' name='cbMigrates_1' className='add-only' value='MIGRATES ONLY' /> N/A MIGRATES ONLY INSIDE TEXAS
                </p>

                <p className='w-750'> <input type='text' id='cbMigrates_2' name='cbMigrates_2' className='add-only' /> </p>

                <p className='w-750'> <input type='text' id='cbMigrates_3' name='cbMigrates_3' className='add-only' /> </p>

                <p className='w-750'> <input type='text' id='cbMigrates_4' name='cbMigrates_4' className='add-only' /> </p>

                <p className='w-750'> <center> <h5> <b> MIGRATING SCHEDULE </b> </h5> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-50'> </td>
                        <td className='w-350'> <span className='eleHeader'> LOCATION </span> </td>
                        <td className='w-350'> <span className='eleHeader'> MONTHS AT LOCATION </span> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> 1. </td>
                        <td className='w-350'> <input type='text' id='txtLocation_1' name='txtLocation_1' className='add-only' /> </td>
                        <td className='w-350'> <input type='text' id='txtMonths_1' name='txtMonths_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> 2. </td>
                        <td className='w-350'> <input type='text' id='txtLocation_2' name='txtLocation_2' className='add-only' /> </td>
                        <td className='w-350'> <input type='text' id='txtMonths_2' name='txtMonths_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-50'> 3. </td>
                        <td className='w-350'> <input type='text' id='txtLocation_3' name='txtLocation_3' className='add-only' /> </td>
                        <td className='w-350'> <input type='text' id='txtMonths_3' name='txtMonths_3' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b> COMPLETE THE FOLLOWING SECTIONS FOR EACH LOCATION LISTED ABOVE: </b> </p>

                <p className='w-750'> <b> LOCATION #1  </b> </p>

                <p className='w-750'> WHERE CLIENT/FAMILY LIVES: </p>

                <table>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'> ADDRESS: </span> </td>
                        <td className='w-100'> <span className='eleHeader'> CITY: </span> </td>
                        <td className='w-100'> <span className='eleHeader'> STATE: </span> </td>
                        <td className='w-100'> <span className='eleHeader'> ZIP: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtAddress_1' name='txtAddress_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtCity_1' name='txtCity_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtState_1' name='txtState_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtZip_1' name='txtZip_1' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b> CONTACT PERSONS:  </b> </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> NAME </span> </td>
                        <td className='w-375'> <span className='eleHeader'> PHONE NUMBE </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_1' name='txtName_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPhone_1' name='txtPhone_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_2' name='txtName_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPhone_2' name='txtPhone_2' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b> MEDICAL PROVIDERS:  </b> </p>

                <table>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'> NAME </span> </td>
                        <td className='w-300'> <span className='eleHeader'> PHONE NUMBE </span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <b> MEDICAL </b> </td>
                        <td className='w-350'> <input type='text' id='txtName_3' name='txtName_3' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtPhone_3' name='txtPhone_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <b> DENTAL </b> </td>
                        <td className='w-350'> <input type='text' id='txtName_4' name='txtName_4' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtPhone_4' name='txtPhone_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <b> SPECIALIST </b> </td>
                        <td className='w-350'> <input type='text' id='txtName_5' name='txtName_5' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtPhone_5' name='txtPhone_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <b> OTHER </b> </td>
                        <td className='w-350'> <input type='text' id='txtName_6' name='txtName_6' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtPhone_6' name='txtPhone_6' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b> SCHOOL ATTENDS: </b> </p>

                <p className='w-750'> <input type='text' id='txtSchool_1' name='txtSchool_1' className='add-only' /> </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> CLIENT NAME: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> MEDICAID NUMBER: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtClientName_4' name='txtClientName_4' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMedicaidNumber_2' name='txtMedicaidNumber_2' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b> LOCATION #2  </b> </p>

                <p className='w-750'> WHERE CLIENT/FAMILY LIVES: </p>

                <table>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'> ADDRESS: </span> </td>
                        <td className='w-100'> <span className='eleHeader'> CITY: </span> </td>
                        <td className='w-100'> <span className='eleHeader'> STATE: </span> </td>
                        <td className='w-100'> <span className='eleHeader'> ZIP: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtAddress_2' name='txtAddress_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtCity_2' name='txtCity_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtState_2' name='txtState_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtZip_2' name='txtZip_2' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b> CONTACT PERSONS:  </b> </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> NAME </span> </td>
                        <td className='w-375'> <span className='eleHeader'> PHONE NUMBE </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_7' name='txtName_7' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPhone_7' name='txtPhone_7' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_8' name='txtName_8' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPhone_8' name='txtPhone_8' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b> MEDICAL PROVIDERS:  </b> </p>

                <table>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'> NAME </span> </td>
                        <td className='w-300'> <span className='eleHeader'> PHONE NUMBE </span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <b> MEDICAL </b> </td>
                        <td className='w-350'> <input type='text' id='txtName_9' name='txtName_9' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtPhone_9' name='txtPhone_9' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <b> DENTAL </b> </td>
                        <td className='w-350'> <input type='text' id='txtName_10' name='txtName_10' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtPhone_10' name='txtPhone_10' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <b> SPECIALIST </b> </td>
                        <td className='w-350'> <input type='text' id='txtName_11' name='txtName_11' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtPhone_11' name='txtPhone_11' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <b> OTHER </b> </td>
                        <td className='w-350'> <input type='text' id='txtName_12' name='txtName_12' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtPhone_12' name='txtPhone_12' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b> SCHOOL ATTENDS: </b> </p>

                <p className='w-750'> <input type='text' id='txtSchool_2' name='txtSchool_2' className='add-only' /> </p>

                <p className='w-750'> <b> LOCATION #3  </b> </p>

                <p className='w-750'> WHERE CLIENT/FAMILY LIVES: </p>

                <table>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'> ADDRESS: </span> </td>
                        <td className='w-100'> <span className='eleHeader'> CITY: </span> </td>
                        <td className='w-100'> <span className='eleHeader'> STATE: </span> </td>
                        <td className='w-100'> <span className='eleHeader'> ZIP: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtAddress_3' name='txtAddress_3' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtCity_3' name='txtCity_3' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtState_3' name='txtState_3' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtZip_3' name='txtZip_3' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b> CONTACT PERSONS:  </b> </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> NAME </span> </td>
                        <td className='w-375'> <span className='eleHeader'> PHONE NUMBE </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_13' name='txtName_13' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPhone_13' name='txtPhone_13' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtName_14' name='txtName_14' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtPhone_14' name='txtPhone_14' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b> MEDICAL PROVIDERS:  </b> </p>

                <table>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'> NAME </span> </td>
                        <td className='w-300'> <span className='eleHeader'> PHONE NUMBE </span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <b> MEDICAL </b> </td>
                        <td className='w-350'> <input type='text' id='txtName_15' name='txtName_15' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtPhone_15' name='txtPhone_15' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <b> DENTAL </b> </td>
                        <td className='w-350'> <input type='text' id='txtName_16' name='txtName_16' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtPhone_16' name='txtPhone_16' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <b> SPECIALIST </b> </td>
                        <td className='w-350'> <input type='text' id='txtName_17' name='txtName_17' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtPhone_17' name='txtPhone_17' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <b> OTHER </b> </td>
                        <td className='w-350'> <input type='text' id='txtName_18' name='txtName_18' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtPhone_18' name='txtPhone_18' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <b> SCHOOL ATTENDS: </b> </p>

                <p className='w-750'> <input type='text' id='txtSchool_3' name='txtSchool_3' className='add-only' /> </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> CLIENT NAME: </span> </td>
                        <td className='w-375'> <span className='eleHeader'> MEDICAID NUMBER: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtClientName_5' name='txtClientName_5' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMedicaidNumber_3' name='txtMedicaidNumber_3' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> ORGANIZATIONS THAT PROVIDE ASSISTANCE TO FAMILY: </span>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMigrantServices' name='cbMigrantServices' className='add-only' value='MIGRANT SERVICES' /> I.S.D. MIGRANT SERVICES/EDUCATION SERVICE CENTERS  <br />
                            <input type='checkbox' id='cbAccelerated' name='cbAccelerated' className='add-only' value='ACCELERATED SERVICES' /> ACCELERATED SERVICES FROM MEDICAID MANAGED CARE PROVIDER <br />
                            <input type='checkbox' id='cbUnitedFarm' name='cbUnitedFarm' className='add-only' value='UNITED FARM' /> UNITED FARM WORKERS <br />
                            <input type='checkbox' id='cbMigrantHealth' name='cbMigrantHealth' className='add-only' value='MIGRANT HEALTH CENTER' /> MIGRANT HEALTH CENTER <br />
                            <input type='checkbox' id='cbNationalCenter' name='cbNationalCenter' className='add-only' value='NATIONAL CENTER' /> NATIONAL CENTER FOR FARM WORKER HEALTH <br />
                            <input type='checkbox' id='cbOther' name='cbOther' className='add-only' value='OTHER' /> OTHER:
                        </td>
                    </tr>
                </table>
                <p className='w-750'> <input type='text' id='txtOther' name='txtOther' className='add-only' /> </p>

                <table>
                    <tr>
                        <td className='signature w-500'> &nbsp; </td>
                        <td className='signature w-250'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> <center> CASE MANAGER SIGNATURE </center> </td>
                        <td className='small w-250'> <center> DATE </center> </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}











